import { Account } from '../../../../globals/store/accounts.data';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FiltersGroupingUI } from 'globals/store/filters-ui.models';
import { filterPageTypes, filtersFeature } from 'src/app/store/filters.era';
import { frontPageFilterUIDataReselector, invitedToEventsReselector } from 'src/app/store/reselectors/filteredEvents.reselector';
import { NewAccountDialogComponent } from './dashboard.dialog.newAccount.component';
import { NewEventDialogComponent } from './dashboard.dialog.newEvent.component';
import { accountEventStates, accountEventStateReselector } from 'src/app/store/reselectors/null.reselector';
import { openDialogGetResult } from './../../helpers/angular-helpers';
import { sleepForMS } from 'src/app/helpers/helpers';
import { DashboardPageType, SortOption, User } from '../../../../globals/store/user.data';
import { UserSettings } from '../../../../globals/store/user.data';
import { JoiEvent } from 'globals/store/events.data';
import { accountsInvitedReselector } from 'src/app/store/reselectors/accounts.reselector';
import { EventViewService } from './../../services/event.view.service';
import { Wrapper } from 'src/app/components/wrapper.component';
import { FrontPageFilterUIParams } from '../../services/filters.service';
import { AuthService } from 'src/app/services/auth.service';
import { AbnormalStateComponent, NullStateData } from './abnormal_state.component';
import { settingsActions, settingsFeature } from 'src/app/store/settings.era';
import { uiActions } from 'src/app/store/ui.era';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { CommonModule } from '@angular/common';
import { DashboardOptionsBarComponent } from './dashboard-options-bar.component';
import { DashboardOptionsPanelComponent } from './dashboard-options-panel';
import { HomeWrapperComponent } from 'src/app/components/nav-bar/home-wrapper.component';
import { accountsFeature } from 'src/app/store/accounts.era';
import { userActions, userFeature } from 'src/app/store/user.era';
import { LogService } from 'src/app/services/log.service';
import { EventViewComponent } from 'src/app/components/events/event-view.component';
import { CalendarComponent } from '../task-calendar/calendar.component';
/**
 * Created by greg on 15/07/2018.
 */

@Component({
    selector: 'dashboard-page',
    animations: [
        trigger('drop', [
            state('true', style({ height: '*' })),
            state('false, null, void', style({ height: '0', padding: 0 })),
            transition('* => *', [animate('300ms')]),
            transition('void => *', [animate('0ms')])
        ]),
        trigger('invite', [
            state('expand', style({ height: '*', opacity: 1 })),
            state('collapse, undefined, void', style({ height: '0', padding: 0, opacity: 0 })),
            transition('* => collapse', [animate('1000ms')]),
            transition('void => *', [animate('0ms')])
        ])
    ],
    templateUrl: './dashboard.page.html',
    styles: [`
    :host{
      width: 100%;
    }`],
    styleUrls: ['./dashboard.page.scss', '../../components/events/event-view.component.scss'],
    imports: [CommonModule, CalendarComponent, EventViewComponent, HomeWrapperComponent, DashboardOptionsPanelComponent, AbnormalStateComponent, IconComponent, DashboardOptionsBarComponent, LoaderPaneFragmentComponent],
    standalone: true,
})
export class DashboardPageComponent extends Wrapper<DashboardPageComponent>  {

  readonly _file: string = 'dashboard.page';
  public showClosed = true;
  public pageType: DashboardPageType = 'card'
  public filter_object = {};
  public svgs = {};
  public expand_mobile_group_panel = false;
  public filterGroupings: FiltersGroupingUI[]
  public filterPage = filterPageTypes.home
  public filterCount: number
  public userSettings: UserSettings
  public accountEventState;
  public accountEventStates = accountEventStates
  public user: User = {} as User
  public invitedToEvents: JoiEvent[]  
  public totalDeclinedEvents = 0 // animiation only
  public invitedAccounts: Account[]
  errorMessage: string
  email_validation = false;
  inactiveAccountIdsSet: Set<string> = new Set()
  selectedAccountIds: string[]
  emailSent
  emailUnverifiedData: NullStateData = {
      message: "Joi now requires email verification to continue.",
      buttonText: "SEND VERIFICATION EMAIL",
      imageClass: "purpleWoman",
    }
  constructor(
    public route: ActivatedRoute,
    private authService: AuthService,
    public eventViewService: EventViewService,
    private log: LogService,
  ) {
    super()
    if (this.router.url.includes('(engage')) {
      const newUrl = this.router.url.split("(engage")[0]
      this.router.navigateByUrl(newUrl)
    }
    this.subCallback(route.queryParams, async params => {
      const code = params['oobCode']
      const mode = params['mode']
      console.log({mode})
      if (mode == "verifyEmail") {
          this.subCallback(this.auth.currentUserData$, u => {
            this.authService.verityCode(code).then(vc => {
              console.log({vc, u})
              this.email_validation = true;
              if(u){
                this.userService.updateUser({emailVerified: true}, false, {file: "login.page.ts", function: "verifyEmail"})
                this.log.nonHsSignUpForm(u);
              // }
              // console.log({u})
              // if (u && u.emailVerified) {
                this.auth.signing_in = false;
                this.auth.reloadUser();
                this.store.dispatch(userActions.verifyEmail())
                this.router.navigate([this.userService.getHomepage(u)])
              }
            }).catch(async error=>{
              this.errorMessage = error.message;
              this.email_validation = true;
            });
          })
      }
    })

    window.scrollTo(0, 0);


    this.subProp(this.store.select('filters','home','count'), 'filterCount')
    this.subProp(this.store.select('filters','home', 'accounts'), 'selectedAccountIds')
    this.subProp(this.store.select('settings','user','event_show_closed'), 'showClosed')
    this.subProp(this.store.select(settingsFeature.selectUser), 'userSettings')
    this.subProp(this.store.select('user', 'user'), 'user')

    this.selectCallback(frontPageFilterUIDataReselector, null, this.buildFiltersOptions.bind(this))
    this.subProp(this.store.select(settingsFeature.selectUserHomepage), 'pageType')

    this.accountEventState = accountEventStates.loading
    // this.subProp(this.store.select(accountEventStateReselector), 'accountEventState') // this is now set in checkIfEmailIsVerified
    this.subCallback(this.store.select(accountEventStateReselector), this.checkIfEmailIsVerified.bind(this))
    this.subCallback(this.store.select(accountsFeature.selectIds), this.checkForNewSubscription.bind(this))

    this.subCallback(this.store.select(invitedToEventsReselector), invitedToEvents => {
      // console.log({ invitedToEvents});
      this.invitedToEvents = invitedToEvents
      if(invitedToEvents.length === 0) this.totalDeclinedEvents = 0;
    })
    this.subProp(this.store.select(accountsInvitedReselector), 'invitedAccounts')

    this.uiService.changePageTitle('Home');
  }

  saveSorting(sortOption: SortOption) {
    this.store.dispatch(settingsActions.updateUserSettings(sortOption))
  }

  savePageType(pageType: DashboardPageType) {
    this.settingsService.saveUserSetting('homepage', pageType)
  }

  async checkIfEmailIsVerified(accountEventState){
    console.log({accountEventState})
    this.accountEventState = accountEventState;
    if(["loading", "emailUnverified"].includes(accountEventState)) return;
    // this.uiService.loadHubSpotScript()
  }

  async checkForNewSubscription(ids: string[]) {
    console.log({ ids, just_created_user: this.auth.just_created_user })
    if (ids.length === 0 || !this.auth.just_created_user) return

    this.store.dispatch(uiActions.updateUIItem('takeover_loading', null))
    this.auth.just_created_user = false;
    await sleepForMS(0)

    const result: any = await openDialogGetResult(this.dialog, NewAccountDialogComponent, { width: '480px', disableClose: true, data: {} })
    if (!result.title_was_changed) return

    this.accountService.updateAccount(
      result.account.id,
      { title: result.account.title } as Partial<Account>,
      { file: this._file, function: 'constructor result.title_was_changed', error: new Error() }
    )

  }

  async buildFiltersOptions(eventViewUIData: FrontPageFilterUIParams) {
    if (!eventViewUIData) {
      this.filterGroupings = null
      return
    }
    this.inactiveAccountIdsSet = eventViewUIData.inactiveAccountIdSet
    const filters = await this.take1(this.store.select(filtersFeature.selectHome));
    console.log({filters})
    const filterUI = this.filtersService.buildFrontPageFilterUI({ ...eventViewUIData, filters })
    this.filterGroupings = filterUI
  }

  async goToSubscription() {
    const ids = await this.take1(this.store.select('accounts', 'ids'))
    this.router.navigate(['/account', ids[0]])
  }

  sendVerificationEmail(){
    console.log('send verification email')
    this.emailUnverifiedData.postMessage = "A verification email has been sent to your email address. Please check your inbox and click the verification link to continue."
    this.emailUnverifiedData.message = undefined;
    this.authService.sendVerificationEmail();
    this.emailSent = true;
  }

  goToSuspendedAccount() {
    this.router.navigate(['/account', this.selectedAccountIds[0]]) // can only select one suspended account at a time
  }

  goToAccounts() {
    this.router.navigate(['/accounts'])
  }

  startNewEvent() {
    // TODO:check all the permissions etc...
    this.openNewEventDialog();
  }
  openNewEventDialog() {
    this.dialog.open(NewEventDialogComponent, { width: '480px', disableClose: true })
  }

  toggle_closed(ev) {
    // this.store.dispatch(new UpdateUserSetting('event_show_closed', ev.checked))
    this.settingsService.saveUserSetting('event_show_closed', ev.checked);
  }

  trackById(index, item) {
    return item.id
  }

  trackByEvent(index, event: JoiEvent) {
    return event.eventId
  }

  
  declineInvitation(event) {
    this.eventService.decline(event)
    this.eventService.recentlyDeclined.add(event.eventId)
    this.totalDeclinedEvents++
    setTimeout(() => {
      setTimeout(() => this.eventService.recentlyDeclined.delete(event.eventId), 100) // in case you want to enable multiple invites / declines per reload shennanigans
    }, 1000)
  }

  async closeEvent(ev: JoiEvent) {
    this.eventViewService.closeEventThroughDialog(ev, this.dialog)
  }


}
